<template>
    <section>
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiAccountCash }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Membership Fee & Philhealth
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>
        <!-- App bar -->

        <div class="memb-fee d-flex justify-space-around flex-wrap">
            <div class="memb-fee-content-wrapper">
                <div class="content">
                    <h3>Payment of Membership fee:</h3>
                    <v-divider />
                    <h6>
                        It is the primary responsibility of the HMI Member to ensure that
                        his/her membership is maintained on an Active Status by paying
                        membership fees on time, and by settling any outstanding obligations
                        with any affiliated Hospitals / Clinics / MSUs where HMI benefits &
                        services were availed.
                    </h6>
                </div>

                <div class="content">
                    <h3>Payment/Lapsation:</h3>
                    <v-divider />

                    <p>
                        The membership fees should be paid by member and must be
                        acknowledged /received by the HMI Cashiering Department 30 days the
                        due date. Membership fees not paid 30 days later before due date
                        shall be considered LAPSED. Lapsed membership is not entitled to
                        medical coverage.
                    </p>

                    <p>
                        HMI Members (Individual/Family) may also conveniently pay their HMI
                        Membership Fees through its partner banks. To know more about this
                        service, kindly proceed to the HMI Billing & Collection Department
                        to apply.
                    </p>

                    <p>
                        Membership shall also be considered lapsed in the occurrence of any
                        of the following:
                    </p>
                    <ul v-for="(lapsation, i) in lapsations" :key="i">
                        <li>{{ lapsation }}</li>
                    </ul>
                </div>
            </div>

            <!-- End Header -->

            <!-- Reinstatement: -->
            <div class="memb-fee-content-wrapper">
                <div class="content">
                    <h3>Reinstatement:</h3>
                    <v-divider />
                    <p>
                        A lapsed membership may be reinstated within three (3) months, from
                        date it has lapsed by:
                    </p>
                    <ul v-for="(reinstatement, i) in reinstatements" :key="i">
                        <li>{{ reinstatement }}</li>
                    </ul>
                </div>
                <div class="content">
                    <!-- Re application -->
                    <h3>Re-Application:</h3>
                    <v-divider />
                    <p>
                        If your membership has lapsed for more than three (3) months, you
                        can re-apply provided the membership has not been terminated or not
                        yet renewed previously or applicant is not more than fifty-nine (59)
                        years old.
                    </p>
                </div>
                <div class="content">
                    <h3>Amendments:</h3>
                    <v-divider />
                    <p>
                        Any changes in your membership such as civil status (from single to
                        married), hospital, dentist, agency, mode of payments, membership
                        type, etc., may be effected by:
                    </p>
                    <ul v-for="(ammend, i) in ammends" :key="i">
                        <li>{{ ammend }}</li>
                    </ul>
                </div>
            </div>

            <!-- Amendments -->
            <div class="memb-fee-content-wrapper">
                <!-- Philhealth -->

                <div class="content">
                    <h3>Philhealth:</h3>
                    <v-divider />
                    <p>
                        Prior to hospital discharge, an HMI member must file the complete
                        documents at the Hospital PhilHealth Section, in accordance to the
                        requirements of PhilHealth.
                    </p>
                    <p>
                        To know the complete documentary list and detailed procedures for
                        filing your PhilHealth benefits, kindly contact PhilHealth directly
                        or inquire at your Hospital’s PhilHealth Section.
                    </p>
                </div>
                <div class="content">
                    <h3>IMPORTANT REMINDER:</h3>
                    <v-divider />
                    <p>
                        Non-PhilHealth Members must enroll in the “HMI NO PHILHEALTH
                        PROGRAM” and must pay the corresponding membership fee to the HMI
                        Office.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mdiAccountCash } from '@mdi/js'

export default {
    data: () => ({
        mdiAccountCash,
        lapsations: [
            'If the member has any unpaid obligation with HMI, such as 	but not confined to excess hospital charges, unpaid 	PhilHealth, outstanding fees, etc.',
            'The Principal and his/her dependents shall be considered as 	one unit. Hence, if the principal and/or any of his 	dependents have any unpaid obligations with HMI, he 	principal and his/her dependents shall be considered 	lapsed, notwithstanding the approval of said request for 	reinstatement.'
        ],
        reinstatements: [
            'Payment of all arrears and penalty charges.',
            'Submission of request of reinstatement/Health Statement.Request of reinstatement is subject to a 7-day processing period and approval of HMI. Request for reinstatement is further subject to the existing underwriting rules and policies of HMI. HMI likewise, shall not be liable to pay, and the member shall not be entitled to, any benefits during the period that membership is lapsed, notwithstanding the approval of said request for reinstatement. '
        ],
        ammends: [
            'Accomplishing an Amendment Form.',
            'Paying the corresponding Amendment Fee.',
            'Attaching your latest HMI Card. '
        ]
    })
}
</script>
<style scoped>
section {
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}

/* Member Fee */
.memb-fee,
.philhealth {
  width: 95%;
  margin: auto;
}
.memb-fee-content-wrapper {
  width: 450px;
}
.content {
  margin-top: 15px;
}
.memb-fee-content-wrapper h3 {
  font-size: 25px;
  color: #1b5e20;
}
.memb-fee-content-wrapper p {
  text-align: justify;
}
.memb-fee-content-wrapper ul li {
  margin-top: 15px;
  font-size: 15px;
}
h6 {
  line-height: 1.5em;
  font-size: 15px;
  font-weight: normal;
  padding: 15px;
}
@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}
@media (max-width: 599px) {
  /* navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    padding-top: 10px;
    font-size: 21px;
  }
  .memb-fee,
  .philhealth {
    width: 90%;
  }
  .memb-fee h2 {
    font-size: 20px;
    text-align: center;
  }
  .memb-fee-content-wrapper p {
    margin-top: 15px;
  }
}
@media (min-width: 599px) and (max-width: 968px) {
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
  .memb-fee-content-wrapper {
    width: 80%;
  }
  .memb-fee-content-wrapper h3,
  h2 {
    text-align: center;
  }
}
@media (min-width: 968px) and (max-width: 1264px) {
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
  .memb-fee-content-wrapper {
    /* border: 1px solid red; */
    width: 30%;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .memb-fee-content-wrapper {
    width: 30%;
  }
}
</style>
